import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";
import { StageController } from "../Components/StageController";

@engineComponent(ComponentTypes.DisplayObject)
export class RenderTextureElement extends BaseElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private baseRenderTexture: PIXI.BaseRenderTexture;

    private renderTexture: PIXI.RenderTexture;

    private texture: PIXI.Texture;

    private sprite: PIXI.Sprite;

    private frameWidth: number;

    private frameHeight: number;

    private frameRectangle: PIXI.Rectangle;

    private zoom: number;

    private view: BaseElement;

    private initialized: boolean;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this.width = 0;
        this.height = 0;
        this.zoom = 1;

        this.initialized = false;
    }

    //******************************************************************************************************************
    //  CREATE/UPDATE
    //******************************************************************************************************************

    create(node: Element): void {
        super.create(node);

        if (node.hasAttribute(RenderTextureElementAttributes.WIDTH)) {
            this.frameWidth = parseInt(node.getAttribute(RenderTextureElementAttributes.WIDTH));
        }

        if (node.hasAttribute(RenderTextureElementAttributes.HEIGHT)) {
            this.frameHeight = parseInt(node.getAttribute(RenderTextureElementAttributes.HEIGHT));
        }

        if (node.hasAttribute(RenderTextureElementAttributes.ZOOM)) {
            this.zoom = parseFloat(node.getAttribute(RenderTextureElementAttributes.ZOOM));
        }
    }

    //******************************************************************************************************************
    //  INIT
    //******************************************************************************************************************

    public initialize(view: BaseElement): void {
        if (!this.initialized) {
            this.view = view;
            let viewSize = this.view.getLocalBounds();

            //create base texture from whole view
            this.baseRenderTexture = new PIXI.BaseRenderTexture(
                viewSize.width,
                viewSize.height,
                PIXI.SCALE_MODES.LINEAR,
                1,
            );

            //create render texture
            this.renderTexture = new PIXI.RenderTexture(this.baseRenderTexture);

            //crete texture from render texture, now we have cached texture from our view container
            this.texture = new PIXI.Texture(this.renderTexture.baseTexture);

            //frame of texture
            this.frameWidth = this.frameWidth > 0 ? this.frameWidth : viewSize.width;
            this.frameHeight = this.frameHeight > 0 ? this.frameHeight : viewSize.height;
            this.frameRectangle = new PIXI.Rectangle(
                0,
                0,
                Math.round(this.frameWidth / this.zoom),
                Math.round(this.frameHeight / this.zoom),
            );

            //set frame to texture
            /*this.texture.frame = this.frameRectangle;
            this.texture._updateUvs();*/

            //create sprite from texture
            this.sprite = new PIXI.Sprite(this.texture);
            this.sprite.scale.set(this.zoom);
            this.addChild(this.sprite);

            // StageController.Renderer.render(this.view, this.renderTexture);
            this.initialized = true;
        }
    }

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    public updateRender(centerX?: number, centerY?: number, width?: number, height?: number): void {
        if (this.initialized) {
            centerX = centerX ? centerX : 0;
            centerY = centerY ? centerY : 0;
            width = width ? width : this.frameWidth;
            height = height ? height : this.frameWidth;

            let w = Math.round(width / this.zoom);
            let h = Math.round(height / this.zoom);

            this.frameRectangle.x = centerX - w * 0.5;
            this.frameRectangle.y = centerY - h * 0.5;

            this.texture.frame = this.frameRectangle;
            this.texture._updateUvs();

            StageController.Renderer.render(this.view, this.renderTexture);
        }
    }

    public orientationChanged(inPortrait: boolean): void {}

    //******************************************************************************************************************
    //  CLONE
    //******************************************************************************************************************

    clone(): RenderTextureElement {
        let element: RenderTextureElement = new RenderTextureElement();

        element.frameWidth = this.frameWidth;
        element.frameHeight = this.frameHeight;
        element.zoom = this.zoom;
        element.view = this.view;

        element.markAsCloned(); // must be called last before return!
        return element;
    }
}

export const RenderTextureElementAttributes = {
    WIDTH: "Width",
    HEIGHT: "Height",
    ZOOM: "Zoom",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/RenderTextureElement.ts
 **/